{
  "global": {
    "hello": "Bonjour",
    "french": "Français",
    "english": "Anglais",
    "list": "Liste des",
    "history": "Historique",
    "light": "Claire",
    "dark": "Sombre",
    "or": "Ou"
  },
  "error": {
    "ERROR_AUTH_INVALID_CREDENTIALS": "Impossible de vous authentifier, veuillez vérifier vos informations de connexion.",
    "ERROR_AUTH_INVALID_TOKEN": "Impossible de vous authentifier lors de la création de votre organisation.",
    "ERROR_AUTH_MISSING_TOKEN": "Impossible de vous authentifier lors de la création de votre organisation.",
    "ERROR_AUTH_SAME_PASSWORD": "Veuillez ne pas utiliser deux fois le même mot de passe.",
    "ERROR_CANDIDATE_ALREADY_IN_CAMPAIGN": "Vous faites déjà partie de la campagne que vous tentez de rejoindre.",
    "ERROR_INVALID_EMAIL": "Adresse e-mail incorrecte ou déjà utilisée.",
    "ERROR_INVALID_FORM": "Il semblerait qu'il y ait un souci lors de la validation de vos données, veuillez vérifier les informations renseignées.",
    "ERROR_INVALID_PHONE": "Le numéro de téléphone renseigné est incorrect.",
    "ERROR_NOT_LONG_ENOUGH": "La saisie ne comprend pas assez de caractères (min. {size} caractères).",
    "ERROR_OPTIN_REQUIRED": "Veuillez lire et accepter les conditions de service et la politique de confidentialité.",
    "ERROR_PARTICIPANT_IN_ASSESSMENT": "Vous ne pouvez pas supprimer une campagne avec des participants en cours d'évaluation.",
    "ERROR_PASSWORD_STRENGTH": "Le mot de passe n'est pas assez sécurisé (min. 1 chiffre, symbole, minuscule, majuscule ainsi que 8 caractères minimum).",
    "ERROR_PASSWORD_NOT_MATCH": "Les deux mots de passe ne correspondent pas.",
    "ERROR_PERMISSIONS_FORBIDDEN": "Vous ne possédez pas les droits pour effectuer cette action.",
    "ERROR_PHONE_ALREADY_USED": "Le numéro de téléphone renseigné est déjà attribué.",
    "ERROR_EMAIL_ALREADY_USED": "Votre adresse e-mail est déjà utilisée dans une autre campagne. Veuillez contacter la personne qui vous a invité(e) pour résoudre le problème.",
    "ERROR_PROVIDED_EMAILS_ALREADY_USED": "Ces adresses e-mail ne peuvent pas être utilisées:",
    "ERROR_PROVIDED_EMAILS_ALREADY_USED_DETAIL": "Elles sont déjà associées à des talents dans une autre campagne. Contactez le support pour résoudre le problème.",
    "ERROR_PROVIDED_EMAIL_ALREADY_USED": "Cette adresse e-mail ne peut pas être utilisée:",
    "ERROR_PROVIDED_EMAIL_ALREADY_USED_DETAIL": "Elle est déjà associée à un talent dans une autre campagne. Contactez le support pour résoudre le problème.",
    "ERROR_REQUIRED_FIELD": "Ce champ est obligatoire, veuillez le remplir pour valider la saisie.",
    "ERROR_TOO_LONG": "Limite de caractères dépassée (Max. {size} caractères).",
    "ERROR_UNKNOWN": "Une erreur inattendue s'est produite. Veuillez réessayer ultérieurement. Si le problème persiste, contactez le support technique."
  },
  "actions": {
    "new": "Nouveau | Nouveaux",
    "add": "Ajouter",
    "create": "Créér",
    "edit": "Modifier",
    "update": "Mettre à jour",
    "delete": "Supprimer",
    "upload": "Importer",
    "download": "Télécharger",
    "move": "Déplacer",
    "logout": "Se déconnecter",
    "signIn": "Se connecter",
    "signUp": "S'inscrire",
    "continue": "Continuer"
  },
  "home": {
    "label": "Accueil"
  },
  "campaign": {
    "label": "Campagne | Campagnes",
    "new": "Nouvelle @.lower:campaign.label",
    "list": "@:global.list @.lower:campaign.label ",
    "test": "Campagne de test",
    "newPage": {
      "essentialPack": "Pack essentiel",
      "campaignName": "Nom de ma campagne",
      "selectSpace": "Choisir mon espace",
      "createCampaign": "Créer votre campagne",
      "modulesIncluded": "Modules inclus",
      "seeMore": "YUZU V2",
      "coming": "Décembre 2024"
    },
    "results": {
      "appreciations": {
        "A": "Ce talent a obtenu un score le situant parmi les meilleurs profils évalués sur cette compétence.",
        "B": "Ce talent a obtenu un meilleur score que la moyenne des profils évalués sur cette compétence.",
        "C": "Ce talent a obtenu un score le situant dans la moyenne des profils évalués sur cette compétence.",
        "D": "Ce talent a obtenu un score inférieur à la moyenne des profils évalués sur cette compétence.",
        "E": "Ce talent a obtenu un score très inférieur à la moyenne des profils évalués sur cette compétence."
      }
    }
  },
  "space": {
    "label": "Espace | Espaces",
    "new": "Nouvel @.lower:space.label",
    "list": "@:global.list @.lower:space.label "
  },
  "report": {
    "label": "Rapport | Rapports"
  },
  "analytic": {
    "label": "Statistique | Statistique"
  },
  "profil": {
    "label": "Mon profil"
  },
  "integration": {
    "label": "Intégration"
  },
  "company": {
    "label": "Paramètres organisation"
  },
  "contact": {
    "label": "Contact"
  },
  "form": {
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmation du nouveau mot de passe",
    "job": "Poste",
    "login": {
      "clientMode": "Plateforme organisation",
      "candidateMode": "Plateforme talent",
      "welcomeBack": "Bonjour, ravi de vous revoir !",
      "rememberMe": "Rester connecté",
      "forgotPassword": "Mot de passe oublié?"
    },
    "register": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "phone": "Numéro de téléphone",
      "confirmPassword": "Confirmation",
      "must8char": "Doit comporter au moins 8 caractères.",
      "company": "Nom de l'organisation",
      "vat_number": "Numéro de TVA",
      "siren_number": "Numéro de SIREN ",
      "address": "Adresse postale",
      "postalCode": "Code postal",
      "city": "Ville",
      "country": "Pays",
      "selectCountry": "Selectionner un pays",
      "optin": "J'ai lu et j'accepte les conditions de service et la politique de confidentialité de Yuzu.",
      "finishRegister": "Terminer mon inscription"
    }
  },
  "candidate_profiles":{
    "discover3": "Découvrez votre top 3 :",
    "gdss_title": "Gestion du stress",
    "gdss_text": "Équilibre, résilience, sérénité, la gestion du stress permet de maintenir un niveau de performance constant pour exceller sous pression.",
    "adpt_title": "Adaptabilité",
    "adpt_text": "Flexibilité, réactivité, anticipation, l’adaptabilité permet d’évoluer avec aisance dans un environnement changeant.",
    "rdpb_title": "Résolution de problèmes",
    "rdpb_text": "Raisonnement, logique, projection, découvrez les secrets de la résolution de problèmes.",
    "discover_more": "Cliquez pour en découvrir plus !",
    "footnote_text":"Ces données sont issues du rapport envoyé au participant à la fin de sa session. La vue ci-dessus est condensée, le participant a accès à plus de détails et d’informations pour chaque compétence.",
    "architect": {
      "title": "Profil Architecte",
      "subtitle": "VOUS FAITES PARTIE DES 6% de PROFILS ARCHITECTES DE LA PLATEFORME",
      "text1": "Les profils architectes ont une appétence marquée pour la résolution de problèmes complexes. Leur capacité à " ,
      "text2": "analyser",
      "text3": " des situations, à ",
      "text4": "identifier",
      "text5": " des solutions novatrices et à ",
      "text6": "structurer",
      "text7": " des plans d'action efficaces les distingue dans l'",
      "text8": "élaboration de stratégies",
      "text9": " et la ",
      "text10": "mise en œuvre de projets",
      "text11": "."
    },
    "balancer": {
      "title": "Profil équilibriste",
      "subtitle": "VOUS FAITES PARTIE DES 25% de PROFILS équilibristes DE LA PLATEFORME",
      "text1": "Les profils équilibriste sont reconnus pour leur " ,
      "text2": "adaptabilité",
      "text3": " et leur ",
      "text4": "gestion remarquable du stress",
      "text5": ". Leur capacité à s'ajuster à des circonstances variées tout en maintenant leur calme et leur efficacité fait d'eux des experts dans la ",
      "text6": "gestion de situations imprévues et stressantes",
      "text7": ".",
      "text8": "",
      "text9": "",
      "text10": "",
      "text11": ""
    },
    "inventor": {
      "title": "Profil inventeur",
      "subtitle": "VOUS FAITES PARTIE DES 17% de PROFILS inventeurs DE LA PLATEFORME",
      "text1": "Les profils inventeurs excellent dans la " ,
      "text2": "résolution de problèmes complexes",
      "text3": " grâce à leur ",
      "text4": "créativité",
      "text5": " et leur ",
      "text6": "adaptabilité",
      "text7": ". Leur capacité à trouver des solutions innovantes et à s'adapter rapidement aux nouvelles situations leur permet de ",
      "text8": "transformer des défis en opportunités concrètes",
      "text9": ".",
      "text10": "",
      "text11": ""
    },
    "minesweeper": {
      "title": "Profil démineur",
      "subtitle": "VOUS FAITES PARTIE DES 14% de PROFILS démineurs DE LA PLATEFORME",
      "text1": "Les profils démineurs brillent par leur gestion exceptionnelle du stress et leur talent pour résoudre des problèmes critiques. Leur " ,
      "text2": "sang-froid",
      "text3": " face à la pression et leur capacité à ",
      "text4": "désamorcer des situations complexes",
      "text5": " font d'eux des experts en situations de crise.",
      "text6": "",
      "text7": "",
      "text8": "",
      "text9": "",
      "text10": "",
      "text11": ""
    },
    "navigator": {
      "title": "Profil navigateur",
      "subtitle": "VOUS FAITES PARTIE DES 26% de PROFILS navigateurs DE LA PLATEFORME",
      "text1": "Les profils navigateurs se caractérisent par leur " ,
      "text2": "flexibilité",
      "text3": " et leur talent pour ",
      "text4": "résoudre des problèmes complexes",
      "text5": ". Leur capacité à s'adapter rapidement et à trouver des solutions pratiques et novatrices les rend particulièrement efficaces dans des ",
      "text6": "environnements dynamiques",
      "text7": " et en ",
      "text8": "constante évolution",
      "text9": ".",
      "text10": "",
      "text11": ""
    },
    "pilot": {
      "title": "Profil pilote",
      "subtitle": "VOUS FAITES PARTIE DES 25% de PROFILS pilotes DE LA PLATEFORME",
      "text1": "Les profils pilotes se distinguent par leur " ,
      "text2": "maîtrise du stress",
      "text3": " et leur ",
      "text4": "grande adaptabilité",
      "text5": ". Leur aptitude à rester calmes sous pression et à naviguer efficacement dans des environnements changeants leur permet de prendre des ",
      "text6": "décisions éclairées et réactives",
      "text7": ".",
      "text8": "",
      "text9": "",
      "text10": "",
      "text11": ""
    }
  }
}
